import { FeedingPlanType } from '../common'

export const idVersionMustNotExist = (data: unknown) => {
  return (
    (data as { id: string; version: number }).id === undefined &&
    (data as { id: string; version: number }).version === undefined
  )
}
export const generateRequiredIdVersionError = (name = '') => ({
  message: `Both 'id' and 'version' must be required together for ${name}`,
  path: ['id', 'version'],
})

export const LYKA_HALF_BOWL_FEEDING_PLAN_TYPES = new Set<FeedingPlanType>([
  FeedingPlanType.half_bowl,
  FeedingPlanType.starter_box_half,
  FeedingPlanType.starter_box_full_1w_over_2w,
])
